/* eslint-disable func-names */
/* eslint-disable no-undef */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-inner-declarations */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/sort-comp */
/* eslint-disable consistent-return */
/* eslint-disable react/no-deprecated */
/* eslint-disable prefer-template */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-rest-params */
/* eslint-disable react/static-property-placement */
import { Component } from "react";
import PropTypes from "prop-types";

const canUseDOM = !!(
	typeof window !== "undefined" &&
	window.document &&
	window.document.createElement
);

export const IntercomAPI = (...args) => {
	if (canUseDOM && window.Intercom) {
		window.Intercom.apply(null, args);
	} else {
		// eslint-disable-next-line no-console
		console.warn("Intercom not initialized yet");
	}
};

export default class Intercom extends Component {
	static propTypes = {
		appID: PropTypes.string.isRequired,
	};

	static displayName = "Intercom";

	constructor(props) {
		super(props);

		const { appID, ...otherProps } = props;

		if (!appID || !canUseDOM) {
			return;
		}

		if (!window.Intercom) {
			(function () {
				const w = window;
				const ic = w.Intercom;
				window.intercomSettings = { ...otherProps, app_id: appID };
				if (typeof ic === "function") {
					ic("reattach_activator");
					ic("update", intercomSettings);
				} else {
					var d = document;
					var i = function () {
						i.c(arguments);
					};
					i.q = [];
					i.c = function (args) {
						i.q.push(args);
					};
					w.Intercom = i;

					function l() {
						var s = d.createElement("script");
						s.type = "text/javascript";
						s.async = true;
						s.defer = true;
						s.rel = "preconnect";
						s.src = `https://widget.intercom.io/widget/${appID}`;
						var x = d.getElementsByTagName("script")[0];
						x.parentNode.insertBefore(s, x);
					}

					function ld() {
						setTimeout(l, 6000);
					}
					if (w.attachEvent) {
						w.attachEvent("onload", ld);
					} else {
						w.addEventListener("load", ld, false);
					}
				}
			})();
		}

		// window.intercomSettings = { ...otherProps, app_id: appID };

		if (window.Intercom) {
			window.Intercom("boot", otherProps);
		}
	}

	componentWillReceiveProps(nextProps) {
		const { appID, ...otherProps } = nextProps;

		if (!canUseDOM) return;

		window.intercomSettings = { ...otherProps, app_id: appID };

		if (window.Intercom) {
			if (this.loggedIn(this.props) && !this.loggedIn(nextProps)) {
				// Shutdown and boot each time the user logs out to clear conversations
				window.Intercom("shutdown");
				window.Intercom("boot", otherProps);
			} else {
				window.Intercom("update", otherProps);
			}
		}
	}

	shouldComponentUpdate() {
		return false;
	}

	loggedIn(props) {
		return props.email || props.user_id;
	}

	componentWillUnmount() {
		if (!canUseDOM || !window.Intercom) return false;

		window.Intercom("shutdown");

		delete window.Intercom;
		delete window.intercomSettings;
	}

	render() {
		return false;
	}
}
